import { ThemeComponents } from '@chakra-ui/react';

export const buttonStyles: { components: ThemeComponents } = {
  components: {
    Button: {
      baseStyle: {
        fontWeight: '500',
        borderRadius: '16px',
        boxShadow: '45px 76px 113px 7px rgba(112, 144, 176, 0.08)',
        transition: '.25s all ease',
        boxSizing: 'border-box',
        _focus: {
          boxShadow: 'none',
        },
        _active: {
          boxShadow: 'none',
        },
      },
      variants: {
        primary: () => ({
          bg: 'primary.500',
          borderRadius: '10px',
          borderWidth: '3px',
          px: '24px',
          borderColor: 'primary.500',
          color: 'primaryText',
          _focus: {
            bg: 'primary.500',
          },
          _active: {
            bg: 'primary.500',
          },
          _hover: {
            bg: 'primary.500',
            opacity: '70%',
            _disabled: {
              bg: 'primary.500',
              opacity: '40%',
            },
          },
        }),
        secondary: () => ({
          bg: 'gray.600',
          borderRadius: '10px',
          borderWidth: '3px',
          px: '24px',
          borderColor: 'gray.600',
          color: 'white',
          _focus: {
            bg: 'gray.600',
          },
          _active: {
            bg: 'gray.600',
          },
          _hover: {
            bg: 'gray.600',
            opacity: '70%',
          },
        }),
        secondaryGray: () => ({
          bg: 'gray.500',
          borderRadius: '10px',
          borderWidth: '3px',
          px: '24px',
          borderColor: 'gray.500',
          color: 'blue.800',
          _focus: {
            bg: 'gray.500',
          },
          _active: {
            bg: 'gray.500',
          },
          _hover: {
            bg: 'gray.500',
            opacity: '70%',
          },
        }),
        outlinePrimary: () => ({
          bg: 'blue.800',
          borderRadius: '10px',
          borderWidth: '3px',
          borderColor: 'primary.500',
          px: '24px',
          color: 'black',
          _focus: {
            bg: 'blue.800',
          },
          _active: {
            bg: 'blue.800',
          },
          _hover: {
            bg: 'blue.800',
            opacity: '70%',
          },
        }),
        outlineSecondary: () => ({
          bg: 'transparent',
          borderRadius: '10px',
          borderWidth: '2px',
          borderColor: 'gray.600',
          px: '24px',
          color: 'gray.600',
          _focus: {
            borderColor: 'black.500',
          },
          _active: {
            borderColor: 'black.500',
          },
          _hover: {
            borderColor: 'black.500',
          },
        }),
        outlineFilter: () => ({
          bg: 'transparent',
          borderRadius: '4px',
          borderWidth: '1px',
          borderColor: 'white',
          fontSize: "xs",
          lineHeight: '20px',
          fontWeight: "semibold",
          h: 5,
          px: 3,
          color: 'white',
          _focus: {
            borderColor: 'gray.500',
          },
          _active: {
            borderColor: 'gray.500',
          },
          _hover: {
            borderColor: 'gray.500',
          },
        }),
        primaryFilter: () => ({
          bg: 'primary.500',
          borderRadius: '4px',
          borderWidth: '1px',
          borderColor: 'primary.500',
          fontSize: "xs",
          lineHeight: '20px',
          fontWeight: "semibold",
          h: 5,
          px: 3,
          color: 'primaryText',
          _focus: {
            borderColor: 'primary.400',
          },
          _active: {
            borderColor: 'primary.400',
          },
          _hover: {
            borderColor: 'primary.400',
          },
        }),
      },
      sizes: {
        xl: {
          fontSize: 'xl',
          h: '60px',
          fontWeight: 'semibold',
        },
        '2xl': {
          fontSize: 'xl',
          h: '74px',
          fontWeight: 'semibold',
        },
      },
    },
  },
};
